import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'hsc-error-page',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="flex h-[calc(100vh-453px)] items-center justify-center">
      <div class="mb-4 text-center">
        <h2 class="mb-2 text-xl font-bold">Oops, looks like an error occurred.</h2>
        <p class="mb-4">Please check the URL or try again later.</p>
        <bolt-button type="solid" href="/">Back to Home</bolt-button>
      </div>
    </div>
  `,
})
export class ErrorPage {}
